/**
 * MNO-IP-Range Datenmodell (Issue #318 Scaffold -> #326 echte Facade-Integration).
 *
 * camelCase-Spiegel des BFF-Contracts (Spec 326, Facade Admin API v2.10). Der BFF
 * mapped PascalCase<->camelCase an der Naht; das Frontend sieht nur camelCase.
 *
 * - Composite Key = `operatorId` + `country.code` (keine synthetische `id` mehr).
 * - `ipRanges` ist pro CIDR, mit server-abgeleiteter `ipVersion` (read-only,
 *   nur Anzeige). Gemischte v4/v6 in einem Eintrag sind erlaubt.
 */

export type MnoIpRangeStatus = 'active' | 'inactive';

/** Contract-String (server-abgeleitet, read-only — nur Anzeige). */
export type MnoIpVersion = 'IPv4' | 'IPv6';

export interface MnoIpRangeCidr {
  cidr: string;
  ipVersion: MnoIpVersion;
}

export interface MnoCountryRef {
  /** ISO-3166-1 alpha-2 (z. B. "DE"). */
  code: string;
  name: string;
}

export interface MnoIpRangeEntry {
  operatorId: string;
  country: MnoCountryRef;
  ipRanges: MnoIpRangeCidr[];
  status: MnoIpRangeStatus;
  label?: string;
  description?: string;
  // Server-verwaltet — der BFF liefert sie bei jedem gelesenen Eintrag (Contract
  // v2.10: required). Daher hier nicht optional.
  createdAt: string;
  /** Optimistic-Lock-Key — beim PUT mitschicken. */
  updatedAt: string;
  updatedBy: string;
}

/** Create-Body Richtung BFF. `cidrs` ohne Version (server-abgeleitet). */
export interface CreateMnoIpRangeInput {
  operatorId: string;
  country: MnoCountryRef;
  cidrs: string[];
  status?: MnoIpRangeStatus;
  label?: string;
  description?: string;
}

/**
 * Update-Body Richtung BFF (partiell). `updatedAt` Pflicht (Optimistic Lock).
 * `cidrs` ersetzt — falls gesetzt — die ganze Liste. `label`/`description`:
 * `null` = entfernen, weglassen = unveraendert.
 */
export interface UpdateMnoIpRangeInput {
  updatedAt: string;
  cidrs?: string[];
  status?: MnoIpRangeStatus;
  label?: string | null;
  description?: string | null;
}

/** Operator-Quelle (Contract-Enum D1_DE/D2_DE/O2_DE). */
export interface MnoOperator {
  operatorId: string;
  name: string;
  /** ISO-3166-1 alpha-2 — Quelle fuer die laenderabhaengige Auswahl (#322). */
  country: string;
}

/** Stabiler client-seitiger Schluessel (react-query-detail, List-key, Routing). */
export function mnoIpRangeKey(operatorId: string, countryCode: string): string {
  return `${operatorId}/${countryCode}`;
}
